var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "crumbs-totals" },
        [_vm._t("breadcrumbs"), _vm._v(" "), _vm._t("totals")],
        2
      ),
      _vm._v(" "),
      _vm._t("groupBy"),
      _vm._v(" "),
      _vm._t("pagination"),
      _vm._v(" "),
      _c("table", { staticClass: "hits-table" }, [
        _c("thead", [
          _c(
            "tr",
            { staticClass: "rounded" },
            [
              _c(
                "th",
                { staticClass: "text-right" },
                [
                  _vm.sortableAnnotations.length
                    ? _c("span", { staticClass: "dropdown" }, [
                        _c(
                          "a",
                          {
                            class: [
                              "dropdown-toggle",
                              { disabled: _vm.disabled },
                            ],
                            attrs: {
                              role: "button",
                              "data-toggle": "dropdown",
                            },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(_vm.leftLabel) +
                                " hit\n\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "caret" }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "dropdown-menu",
                            attrs: { role: "menu" },
                          },
                          _vm._l(
                            _vm.sortableAnnotations,
                            function (annotation) {
                              return _c(
                                "li",
                                {
                                  key: annotation.id,
                                  class: { disabled: _vm.disabled },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "sort",
                                      attrs: { role: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeSort(
                                            _vm.beforeField +
                                              ":" +
                                              annotation.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(annotation.displayName) + " "
                                      ),
                                      _c("Debug", [
                                        _vm._v(
                                          "(id: " + _vm._s(annotation.id) + ")"
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ])
                    : [_vm._v(_vm._s(_vm.leftLabel) + " hit")],
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "th",
                { staticClass: "text-center" },
                [
                  _vm.sortableAnnotations.length
                    ? _c("span", { staticClass: "dropdown" }, [
                        _c(
                          "a",
                          {
                            class: [
                              "dropdown-toggle",
                              { disabled: _vm.disabled },
                            ],
                            attrs: {
                              role: "button",
                              "data-toggle": "dropdown",
                            },
                          },
                          [
                            _vm._v("\n\t\t\t\t\t\t\tHit\n\t\t\t\t\t\t\t"),
                            _c("span", { staticClass: "caret" }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "dropdown-menu",
                            attrs: { role: "menu" },
                          },
                          _vm._l(
                            _vm.sortableAnnotations,
                            function (annotation) {
                              return _c(
                                "li",
                                {
                                  key: annotation.id,
                                  class: { disabled: _vm.disabled },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "sort",
                                      attrs: { role: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeSort(
                                            "hit:" + annotation.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(annotation.displayName) + " "
                                      ),
                                      _c("Debug", [
                                        _vm._v(
                                          "(id: " + _vm._s(annotation.id) + ")"
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ])
                    : [_vm._v("Hit")],
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "th",
                { staticClass: "text-left" },
                [
                  _vm.sortableAnnotations.length
                    ? _c("span", { staticClass: "dropdown" }, [
                        _c(
                          "a",
                          {
                            class: [
                              "dropdown-toggle",
                              { disabled: _vm.disabled },
                            ],
                            attrs: {
                              role: "button",
                              "data-toggle": "dropdown",
                            },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(_vm.rightLabel) +
                                " hit\n\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "caret" }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          {
                            staticClass: "dropdown-menu",
                            attrs: { role: "menu" },
                          },
                          _vm._l(
                            _vm.sortableAnnotations,
                            function (annotation) {
                              return _c(
                                "li",
                                {
                                  key: annotation.id,
                                  class: { disabled: _vm.disabled },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      class: [
                                        "sort",
                                        { disabled: _vm.disabled },
                                      ],
                                      attrs: { role: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeSort(
                                            _vm.afterField + ":" + annotation.id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(annotation.displayName) + " "
                                      ),
                                      _c("Debug", [
                                        _vm._v(
                                          "(id: " + _vm._s(annotation.id) + ")"
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ])
                    : [_vm._v(_vm._s(_vm.rightLabel) + " hit")],
                ],
                2
              ),
              _vm._v(" "),
              _vm._l(_vm.shownAnnotationCols, function (annotation) {
                return _c(
                  "th",
                  { key: annotation.id },
                  [
                    annotation.hasForwardIndex
                      ? _c(
                          "a",
                          {
                            class: ["sort", { disabled: _vm.disabled }],
                            attrs: {
                              role: "button",
                              title: "Sort by " + annotation.displayName,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.changeSort("hit:" + annotation.id)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(annotation.displayName) +
                                " "
                            ),
                            _c("Debug", [
                              _vm._v("(id: " + _vm._s(annotation.id) + ")"),
                            ]),
                          ],
                          1
                        )
                      : [_vm._v(_vm._s(annotation.displayName))],
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _vm._l(_vm.shownMetadataCols, function (meta) {
                return _c("th", { key: meta.id }, [
                  _c(
                    "a",
                    {
                      class: ["sort", { disabled: _vm.disabled }],
                      attrs: {
                        role: "button",
                        title: "Sort by " + meta.displayName,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.changeSort("field:" + meta.id)
                        },
                      },
                    },
                    [
                      _vm._v("\n\t\t\t\t\t\t" + _vm._s(meta.displayName) + " "),
                      _c("Debug", [_vm._v("(id: " + _vm._s(meta.id) + ")")]),
                    ],
                    1
                  ),
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.shownGlossCols, function (fieldName, i) {
                return _c("th", { key: i }, [
                  _c(
                    "a",
                    {
                      staticClass: "sort gloss_field_heading",
                      attrs: { title: "User gloss field: " + fieldName },
                    },
                    [_vm._v(_vm._s(fieldName))]
                  ),
                ])
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.rows, function (rowData, index) {
              return [
                rowData.type === "doc"
                  ? _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showTitles,
                            expression: "showTitles",
                          },
                          {
                            name: "tooltip",
                            rawName: "v-tooltip.top-start",
                            value: {
                              show: _vm.pinnedTooltip === index,
                              content: "Document id: " + rowData.docPid,
                              trigger:
                                _vm.pinnedTooltip === index
                                  ? "manual"
                                  : "hover",
                              targetClasses:
                                _vm.pinnedTooltip === index
                                  ? "pinned"
                                  : undefined,
                              hideOnTargetClick: false,
                              autoHide: false,
                            },
                            expression:
                              "{\n\t\t\t\t\t\tshow: pinnedTooltip === index,\n\t\t\t\t\t\tcontent: `Document id: ${rowData.docPid}`,\n\t\t\t\t\t\ttrigger: pinnedTooltip === index ? 'manual' : 'hover',\n\t\t\t\t\t\ttargetClasses: pinnedTooltip === index ? 'pinned' : undefined,\n\t\t\t\t\t\thideOnTargetClick: false,\n\t\t\t\t\t\tautoHide: false,\n\t\t\t\t\t}",
                            modifiers: { "top-start": true },
                          },
                        ],
                        key: index,
                        staticClass: "document rounded",
                        on: {
                          click: function ($event) {
                            _vm.pinnedTooltip =
                              _vm.pinnedTooltip === index ? null : index
                          },
                        },
                      },
                      [
                        _c("td", { attrs: { colspan: _vm.numColumns } }, [
                          _c(
                            "a",
                            {
                              staticClass: "doctitle",
                              attrs: { target: "_blank", href: rowData.href },
                            },
                            [_vm._v(_vm._s(rowData.summary))]
                          ),
                        ]),
                      ]
                    )
                  : rowData.type === "hit"
                  ? [
                      _c(
                        "tr",
                        {
                          key: index,
                          class: [
                            "concordance",
                            "rounded interactable",
                            {
                              open:
                                _vm.citations[index] &&
                                _vm.citations[index].open,
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.showCitation(index)
                            },
                          },
                        },
                        [
                          _vm.concordanceAsHtml
                            ? [
                                _c("td", { staticClass: "text-right" }, [
                                  _vm._v("…"),
                                  _c("span", {
                                    attrs: { dir: _vm.textDirection },
                                    domProps: {
                                      innerHTML: _vm._s(rowData.left),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-center" }, [
                                  _c("strong", {
                                    attrs: { dir: _vm.textDirection },
                                    domProps: {
                                      innerHTML: _vm._s(rowData.hit),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c("span", {
                                    attrs: { dir: _vm.textDirection },
                                    domProps: {
                                      innerHTML: _vm._s(rowData.right),
                                    },
                                  }),
                                  _vm._v("…"),
                                ]),
                              ]
                            : [
                                _c("td", { staticClass: "text-right" }, [
                                  _vm._v("…"),
                                  _c(
                                    "span",
                                    { attrs: { dir: _vm.textDirection } },
                                    [_vm._v(_vm._s(rowData.left))]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-center" }, [
                                  _c(
                                    "strong",
                                    { attrs: { dir: _vm.textDirection } },
                                    [_vm._v(_vm._s(rowData.hit))]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "span",
                                    { attrs: { dir: _vm.textDirection } },
                                    [_vm._v(_vm._s(rowData.right))]
                                  ),
                                  _vm._v("…"),
                                ]),
                              ],
                          _vm._v(" "),
                          _vm._l(rowData.other, function (v, index) {
                            return _c("td", { key: index }, [_vm._v(_vm._s(v))])
                          }),
                          _vm._v(" "),
                          _vm._l(rowData.gloss_fields, function (field) {
                            return _c(
                              "td",
                              {
                                key: field.fieldName,
                                staticStyle: { overflow: "visible" },
                              },
                              [
                                _c("GlossField", {
                                  attrs: {
                                    fieldName: field.fieldName,
                                    hit_first_word_id:
                                      rowData.hit_first_word_id,
                                    hit_last_word_id: rowData.hit_last_word_id,
                                    fieldDescription: field,
                                    hitId: rowData.hit_id,
                                  },
                                }),
                              ],
                              1
                            )
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.shownMetadataCols, function (meta) {
                            return _c("td", { key: meta.id }, [
                              _vm._v(
                                _vm._s(
                                  rowData.doc[meta.id]
                                    ? rowData.doc[meta.id].join(", ")
                                    : ""
                                )
                              ),
                            ])
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.citations[index]
                        ? _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.citations[index].open,
                                  expression: "citations[index].open",
                                },
                              ],
                              key: index + "-citation",
                              class: [
                                "concordance-details",
                                { open: _vm.citations[index].open },
                              ],
                            },
                            [
                              _c("td", { attrs: { colspan: _vm.numColumns } }, [
                                _vm.citations[index].error
                                  ? _c("p", { staticClass: "text-danger" }, [
                                      _c("span", {
                                        staticClass:
                                          "fa fa-exclamation-triangle",
                                      }),
                                      _vm._v(" "),
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.citations[index].error
                                          ),
                                        },
                                      }),
                                    ])
                                  : _vm.citations[index].citation
                                  ? _c(
                                      "p",
                                      [
                                        _vm._l(
                                          _vm.citations[index].addons,
                                          function (addon) {
                                            return [
                                              addon.component
                                                ? _c(
                                                    addon.component,
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          key: addon.name,
                                                          tag: "component",
                                                          class:
                                                            "addon addon-" +
                                                            addon.name +
                                                            " " +
                                                            ((addon.props &&
                                                              addon.props
                                                                .class) ||
                                                              ""),
                                                        },
                                                        "component",
                                                        addon.props,
                                                        false
                                                      ),
                                                      addon.listeners
                                                    ),
                                                    [
                                                      addon.content
                                                        ? _c("div", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                addon.content
                                                              ),
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                : _c(
                                                    addon.element || "div",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          key: addon.name,
                                                          tag: "component",
                                                          class:
                                                            "addon addon-" +
                                                            addon.name +
                                                            " " +
                                                            ((addon.props &&
                                                              addon.props
                                                                .class) ||
                                                              ""),
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              addon.content
                                                            ),
                                                          },
                                                        },
                                                        "component",
                                                        addon.props,
                                                        false
                                                      ),
                                                      addon.listeners
                                                    )
                                                  ),
                                            ]
                                          }
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { attrs: { dir: _vm.textDirection } },
                                          [
                                            _vm.concordanceAsHtml
                                              ? [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.citations[index]
                                                          .citation.left
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("strong", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.citations[index]
                                                          .citation.hit
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href: _vm.citations[
                                                          index
                                                        ].href,
                                                        title:
                                                          "Go to hit in document",
                                                        target: "_blank",
                                                      },
                                                    },
                                                    [
                                                      _c("sup", {
                                                        staticClass:
                                                          "fa fa-link",
                                                        staticStyle: {
                                                          "margin-left": "-5px",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.citations[index]
                                                          .citation.right
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              : [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.citations[index]
                                                          .citation.left
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.citations[index]
                                                          .citation.hit
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href: _vm.citations[
                                                          index
                                                        ].href,
                                                        title:
                                                          "Go to hit in document",
                                                        target: "_blank",
                                                      },
                                                    },
                                                    [
                                                      _c("sup", {
                                                        staticClass:
                                                          "fa fa-link",
                                                        staticStyle: {
                                                          "margin-left": "-5px",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.citations[index]
                                                          .citation.right
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                          ],
                                          2
                                        ),
                                      ],
                                      2
                                    )
                                  : _c("p", [
                                      _c("span", {
                                        staticClass: "fa fa-spinner fa-spin",
                                      }),
                                      _vm._v(" Loading...\n\t\t\t\t\t\t\t"),
                                    ]),
                                _vm._v(" "),
                                _vm.shownConcordanceAnnotationRows.length
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          overflow: "auto",
                                          "max-width": "100%",
                                          "padding-bottom": "15px",
                                        },
                                      },
                                      [
                                        _c(
                                          "table",
                                          {
                                            staticClass:
                                              "concordance-details-table",
                                          },
                                          [
                                            _c("thead", [
                                              _c("tr", [
                                                _c("th", [_vm._v("Property")]),
                                                _vm._v(" "),
                                                _c(
                                                  "th",
                                                  {
                                                    attrs: {
                                                      colspan:
                                                        rowData.props.punct
                                                          .length,
                                                    },
                                                  },
                                                  [_vm._v("Value")]
                                                ),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "tbody",
                                              _vm._l(
                                                _vm.shownConcordanceAnnotationRows,
                                                function (annot) {
                                                  return _c(
                                                    "tr",
                                                    { key: annot.id },
                                                    [
                                                      _c("th", [
                                                        _vm._v(
                                                          _vm._s(
                                                            annot.displayName
                                                          )
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        rowData.props[annot.id],
                                                        function (v, index) {
                                                          return _c(
                                                            "td",
                                                            { key: index },
                                                            [_vm._v(_vm._s(v))]
                                                          )
                                                        }
                                                      ),
                                                    ],
                                                    2
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _vm._t("sort"),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-sm",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  _vm.showTitles = !_vm.showTitles
                },
              },
            },
            [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(_vm.showTitles ? "Hide" : "Show") +
                  " Titles\n\t\t"
              ),
            ]
          ),
          _vm._v(" "),
          _vm._t("export"),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }